// src/store/index.js
import { configureStore, createSlice } from '@reduxjs/toolkit';

// Lead Form Slice
const leadFormSlice = createSlice({
  name: 'leadForm',
  initialState: {
    formData: {
      name: '',
      email: '',
      phone: '',
      projectType: '',
      budget: '',
      timeline: '',
      message: ''
    },
    submissions: [],
    isSubmitting: false,
    submitSuccess: false,
    submitError: null
  },
  reducers: {
    updateFormField: (state, action) => {
      const { field, value } = action.payload;
      state.formData[field] = value;
    },
    submitFormStart: (state) => {
      state.isSubmitting = true;
      state.submitError = null;
    },
    submitFormSuccess: (state, action) => {
      state.isSubmitting = false;
      state.submitSuccess = true;
      state.submissions.push({
        ...state.formData,
        id: Date.now(),
        submittedAt: new Date().toISOString()
      });
      // Reset form
      state.formData = {
        name: '',
        email: '',
        phone: '',
        projectType: '',
        budget: '',
        timeline: '',
        message: ''
      };
    },
    submitFormFailure: (state, action) => {
      state.isSubmitting = false;
      state.submitError = action.payload;
    },
    resetFormStatus: (state) => {
      state.submitSuccess = false;
      state.submitError = null;
    }
  }
});

export const {
  updateFormField,
  submitFormStart,
  submitFormSuccess,
  submitFormFailure,
  resetFormStatus
} = leadFormSlice.actions;

export const store = configureStore({
  reducer: {
    leadForm: leadFormSlice.reducer
  }
});